import { Link } from "react-router-dom";
import styled from "styled-components";

type BreadcrumbsProps = {
    building?: {
        label: string;
        href: string;
    };
    subBuilding?: {
        label: string;
        href: string;
    };
    techSektor?: {
        label: string;
        href: string;
    };
    className?: string;
}

const BreadcrumbsContainer = styled.div`
    display: flex;
    align-items: center;
    font-size: ${props => props.theme.typography.xs};
    color: ${props => props.theme.colors.white || '#fff'};
    margin: 0;
    padding-left: 20px;

    @media ${props => props.theme.screens.lg} {
        font-size: ${props => props.theme.typography.md};
    }
`;

const BreadcrumbLink = styled(Link)<{ $isActive?: boolean }>`
    color: ${props => {
        return props.theme.colors.white || '#fff';
    }};
    text-decoration: none;
    transition: color 100ms ease-in;
    pointer-events: ${props => props.$isActive ? 'none' : 'auto'};

    &:hover {
        color: ${props => props.$isActive ? 'inherit' : props.theme.colors.primaryLight};
        text-decoration: ${props => props.$isActive ? 'none' : 'underline'};
    }
`;

const BreadcrumbSeparator = styled.span`
    display: flex;
    align-items: center;
    margin: 0 8px;
    width: 10px;
    aspect-ratio: 1/1;
    background: white;
    clip-path: polygon(0% 45%, 80% 45%, 45% 0%, 60% 0%, 100% 50%, 60% 100%, 45% 100%, 80% 55%, 0% 55%);
`;

const BreadcrumbItemWrapper = styled.span`
    display: flex;
    align-items: center;
`;

export const BreadcrumbsWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    z-index: 100;
    background: linear-gradient(90deg,rgba(14, 35, 61, 1) 0%, rgba(14, 35, 61, .7) 50%, rgba(255, 255, 255, 0) 100%);
`;

export const ButtonsWrapper = styled.div<{isCity?: boolean}>`
    display: flex;
    align-items: center;
    gap: 2px;
    ${props => props.isCity ?
        `position: absolute;
        z-index: 10000;
        right: 0;`
    : ''}
`;

export const StyledContactButton = styled.a`
    background: ${(props) => props.theme.colors.primary};
    padding: 2px 1px;
    text-align: center;
    text-decoration: none;

    svg {
        width: 20px;
        aspect-ratio: 1 / 1;
    }
    p {
        color: ${(props) => props.theme.colors.white};
        font-size: ${(props) => props.theme.typography.sm};
        margin: 0;
        text-decoration: none;
    }

    @media ${(props) => props.theme.screens.lg} {
        padding: 5px;

        svg {
            width: 30px;
        }
    }
`;

const Breadcrumbs = ({ building, subBuilding, techSektor, className }: BreadcrumbsProps) => {
    return (
        <BreadcrumbsContainer className={className}>
            <BreadcrumbItemWrapper key='home'>
                <BreadcrumbLink $isActive={!building && !techSektor} to='/'>
                    KSBuilding City
                </BreadcrumbLink>
                {(building || techSektor) && <BreadcrumbSeparator />}
            </BreadcrumbItemWrapper>

            {building && (
                <BreadcrumbItemWrapper key='building'>
                    <BreadcrumbLink $isActive={!techSektor && !subBuilding} to={building.href}>
                        {building.label}
                    </BreadcrumbLink>
                    {(techSektor || subBuilding) && <BreadcrumbSeparator />}
                </BreadcrumbItemWrapper>
            )}

            {techSektor && (
                <BreadcrumbItemWrapper key='techsektor'>
                    <BreadcrumbLink $isActive={!subBuilding} to={(building?.href || '') + '/' + (techSektor.href.split('/').pop() || '')}>
                        {techSektor.label}
                    </BreadcrumbLink>
                    {subBuilding && <BreadcrumbSeparator />}
                </BreadcrumbItemWrapper>
            )}

            {subBuilding && (
                <BreadcrumbItemWrapper key='subBuilding'>
                    <BreadcrumbLink $isActive={true} to={''}>
                        {subBuilding.label}
                    </BreadcrumbLink>
                </BreadcrumbItemWrapper>
            )}
        </BreadcrumbsContainer>
    );
};

export default Breadcrumbs;